import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-gbp-location-mapping-modal',
  templateUrl: './location-mapping-modal.component.html',
})
export class GbpLocationMappingModalComponent {
  location: any;

  constructor(
    public dialogRef: MatDialogRef<GbpLocationMappingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService
  ) {
    this.location = data.location;
    if (!this.location.mapping) {
      this.location.mapping = {
        city: '',
        urlPathWp: '',
        service: '',
        industry: ''
      };
    }
  }

  save() {
    const body = {
      mapping: this.location.mapping,
      status: this.location.status
    };

    this.dataService.putData(`gbpLocations/mapping/${this.location._id}`, body).subscribe(res => {
      if (res.rst) {
        this.dialogRef.close(true);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
